// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__cXRn1","log":"ModalInventoryLogs_log__1ydCT","date":"ModalInventoryLogs_date__fHiuV","userName":"ModalInventoryLogs_userName__1cQan"};